'use client';
import { Term } from '@benzinga/content-manager';
import { NewsListItemElement } from '@benzinga/news';
import classNames from 'classnames';

type ClientNewsListElementProps = {
  inLineTicker?: any;
  article: any;
  showFull?: boolean;
  showTicker?: boolean;
  variant?: 'default' | 'outline';
  primaryTerm?: Term | undefined;
  className?: string;
  showImage?: boolean;
};

export const ClientNewsListElement = ({
  inLineTicker = true,
  article,
  showFull = true,
  showTicker = true,
  primaryTerm = undefined,
  variant = 'default',
  className,
  showImage: showImageProp,
}: ClientNewsListElementProps) => {
  const showImage = showImageProp ?? (variant === 'outline' ? false : showFull);
  const showTeaser = variant === 'outline' ? true : showFull;

  return (
    <div
      className={classNames(
        'bg-white rounded-sm p-2',
        variant === 'outline' ? 'border border-gray-200 rounded-md' : undefined,
        className,
      )}
    >
      <NewsListItemElement
        inLineTicker={showTicker && inLineTicker}
        node={article}
        showCommentsIcon={false}
        showImage={showImage}
        showTeaser={showTeaser}
        showTicker={showTicker}
        primaryTerm={primaryTerm}
        maxVisibleTickers={1}
      />
    </div>
  );
};
